export function isPastDate(inputDate: string | Date): boolean {
    const date = typeof inputDate === "string" ? new Date(inputDate) : inputDate;
  
    if (isNaN(date.getTime())) {
      return false
    }
  
    const now = new Date();
  
    return date < now;
  }
   